
import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
//import {Row, Col, Container, Card} from 'react-bootstrap';
import { Row, Col, Container, Card, Button, InputGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';
import { toast } from "react-toastify";

// import Select from 'react-select';

const Update_Chq_Rcpt = () => {

  const [isEditable, setIsEditable] = useState(false);
  const [ddlSection, setDdlSection] = useState([]);
  const [errors, setErrors] = useState({});
  const [rowErrors, setRowErrors] = useState({});
  const [isRecordFound, setIsRecordFound] = useState(false);

  // Header State
  const [headerData, setHeaderData] = useState({
    clear_date: new Date().toISOString().split("T")[0],
  });

  // Child Table Data
  const [childRows, setChildRows] = useState([
    {
      section_id: "",
      receipt_no: "",
      gr_no: "",
      year1: "",
      receipt_date: "",
      student_name: "",
      instr_no_bank: "",
      fee_amt: 0,
      chq_clear: false,
      cancelled_remark: ""
    }
  ]);

  const handleHeaderChange = (e) => {

    const { name, value } = e.target;

    setHeaderData(prev => ({ ...prev, [name]: value }));

    if (name === 'year1') {
       setHeaderData(prev => ({ ...prev, year2: Number(value) + 1 }));
    }

    setErrors(prev => ({ ...prev, [name]: "" }));

  };

  const handleChildChange = async (index, e) => {

    const { name, value, type, checked } = e.target;

    const rows = [...childRows];

    if (type === "checkbox") {
        rows[index][name] = checked;
        // If cheque is cleared, clear the cancelled remark
        if (checked) {
            rows[index].cancelled_remark = "";
        }
    } else {
        rows[index][name] = value;
    }

    setChildRows(rows);

  };

  useEffect(() => {
    const fetchLists = async () => {

      populateReceipts();

    };
    fetchLists();
  }, []);

  const populateReceipts = async () => {

    try {

      resetPage();
      setIsRecordFound(false);

      const result = await axios.get(`${BASE_URL}/api/get_chq_rcpt`);

      if (result.data.length > 0) {
        setChildRows(result.data);
        setIsRecordFound(true);
      }

    } catch (err) {
      console.error("receipts fetch error:", err);
    }

  }

  const handleNew = () => {

    resetPage();
    setIsEditable(true);

  };

  const handleSave = async () => {

    const hasSelectionOrRemarks = childRows.some(
      (row) =>
        row.chq_clear === true ||
        (row.cancelled_remark && row.cancelled_remark.trim() !== "")
    );

    if (!hasSelectionOrRemarks) {
      toast.error("Please select at least one cheque as cleared or enter remarks.");
      return;
    }

    const isConfirmed = window.confirm("Update selected Receipts ?");

    if (!isConfirmed) return;

    const updRcptdata = {
      header: headerData,
      details: childRows,
    };

    const response = await axios.post(`${BASE_URL}/api/upd_chq_rcpt`, updRcptdata);

    if (response.data.message === '1') {
      toast.success('Cheque Receipts updated successfully.');
      resetPage();
      populateReceipts();
    } else {
      toast.error('Unable to update receipts.');
    }

  };

  const formatAmount = (amount) => {

    return Number(amount || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  };

  const resetPage = () => {

    setIsEditable(false);
    setHeaderData({ clear_date: new Date().toISOString().split("T")[0] });

    setChildRows([{ section_id: "", receipt_no: "", year1: "", receipt_date: "", student_name: "", gr_no: "",
                    instr_no_bank: "", fee_amt: 0, chq_clear: false, cancelled_remark: ""}]);

  }

  const handleClear = () => {
    if (window.confirm("Clear all data?")) {
      resetPage();
      populateReceipts();
    }
  };

  return (
    <Container fluid className="p-3">
      <Card className="mb-4 p-3">

        <Row className="mb-3">

          <Col md={4}>
            <InputGroup>

              <InputGroup.Text style={{ width: "170px" }}>
                Cheque Clear Date
              </InputGroup.Text>

              <input
                type="date"
                className="form-control"
                name="clear_date"
                value={headerData.clear_date}
                onChange={handleHeaderChange}
              />

            </InputGroup>

          </Col>

          <Col className="d-flex justify-content-end gap-2">

            <button className="btn btn-secondary" style={{ width: "120px" }} onClick={handleClear} > Clear
            </button>

            <button className="btn btn-success" style={{ width: "120px" }}
               disabled={isRecordFound === false} onClick={handleSave} > Save
            </button>

          </Col>

        </Row>
        

        {/* <div className="d-flex justify-content-end gap-2 mt-3 flex-wrap">

          <button
            type="button"
            className="btn btn-primary"
            style={{ width: "135px" }}
            onClick={handleNew}
            disabled={isEditable}
          >New
          </button>

          <button
            type="button"
            className="btn btn-secondary"
            style={{ width: "135px" }}
            onClick={handleClear}
          > Clear
          </button>

          <button
            type="button"
            className="btn btn-success"
            style={{ width: "135px" }}
            onClick={handleSave}
            disabled={!isEditable}
          > Save
          </button>
        </div> */}

      </Card>

      {/* Child Table */}
      <Card className="p-3">
        <div style={{ minHeight: '220px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">
            <thead>
              <tr>
                {/* <th style={{ width: '4%', textAlign: 'center' }}>#</th> */}
                <th style={{ width: "10%" }}>Receipt No.</th>
                <th style={{ width: "8%" }}>Receipt Date</th>
                <th style={{ width: "26%" }}>GR No. / Student Name</th>
                <th style={{ width: "15%" }}>Cheque / Bank</th>
                <th style={{ width: "10%", textAlign: "right" }}>Amount</th>
                <th style={{ width: "8%", textAlign: "center" }}>Chq Cleared</th>
                <th style={{ width: "18%" }}>Chq Not Clear (Remarks)</th>
              </tr>
            </thead>

            <tbody>
              {childRows.length > 0 ? (
                childRows.map((row, index) => (

                  <tr key={index}>

                    <td>{row.receipt_no}</td>
                    <td>{row.receipt_date}</td>
                    <td>{row.student_name}</td>
                    <td>{row.instr_no_bank}</td>
                    <td style={{ textAlign: "right" }}>
                      {formatAmount(row.fee_amt)}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <input
                        type="checkbox"
                        name="chq_clear"
                        checked={row.chq_clear}
                        onChange={(e) => handleChildChange(index, e)}
                      />
                    </td>

                    <td>
                      <input
                        type="text"
                        className="form-control"
                        name="cancelled_remark"
                        value={row.cancelled_remark}
                        onChange={(e) => handleChildChange(index, e)}
                        disabled={row.chq_clear}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No Entry found
                  </td>
                </tr>
              )}

            </tbody>

          </table>
        </div>

      </Card>

      {/* Buttons */}
    </Container>
  );
};

export default Update_Chq_Rcpt;
